import { SearchOutlined } from '@ant-design/icons';
import { useFormContext, withForm } from '@oscar/form';
import { ActionButtons } from '@oscar/table';
import { Button, Col, Form, Input, Row, Select } from '@oscar/theme';
import { useDeepCompareEffect } from '@oscar/utils';
import { APIS } from 'common/constants/endpoints';
import { debounce } from 'lodash';
import React from 'react';
import AddEditPopup from './AddEditPopup';

const { useForm } = Form;
const { Option } = Select;

export type SearchToolProps = {
  actionTable?: any;
  metadata?: any;
};

const SearchTool: React.FC<SearchToolProps> = ({ actionTable, metadata }) => {
  const [formContext] = useFormContext();
  const [form] = useForm();
  const [showAddPopup, setShowAddPopup] = React.useState(false);
  const insulationDetail =
    formContext.selectors?.getDataByKey('getinsulationDetail') || {};

  useDeepCompareEffect(() => {
    form.setFieldsValue(metadata?.filters);
  }, [metadata]);

  const handleApplicableServiceChange = (value: any) => {
    if (value.length > 0) {
      actionTable?.methods?.fetchData({
        filters: { applicableServices: value },
      });
    } else {
      actionTable?.methods?.fetchData({
        filters: { applicableServices: null },
      });
    }
  };

  const handleAresChange = (value: any) => {
    if (value.length > 0) {
      actionTable?.methods?.fetchData({
        filters: { areas: value },
      });
    } else {
      actionTable?.methods?.fetchData({
        filters: { areas: null },
      });
    }
  };

  const handleSearchEnter = debounce((value: any) => {
    actionTable?.methods?.fetchData({
      filters: { keyWord: value },
    });
  }, 500);

  return (
    <>
      <Form layout="vertical" form={form}>
        <div className="group-fillter-request">
          <Row key="filter-request" gutter={16}>
            <Col span={11}>
              <Form.Item
                name="keyWord"
                label="Search company"
                className="title-filter-request"
                getValueFromEvent={(e: any) => {
                  handleSearchEnter(e.target.value);
                  return e.target.value;
                }}
              >
                <Input
                  size="large"
                  placeholder="Search company name..."
                  prefix={<SearchOutlined />}
                  maxLength={100}
                />
              </Form.Item>
            </Col>

            <Col span={5}>
              <Form.Item
                name="applicableService"
                label="Applicable service"
                className="title-filter-request"
                getValueFromEvent={(value: any) => {
                  handleApplicableServiceChange(value);
                  return value;
                }}
              >
                <Select
                  mode="multiple"
                  size="large"
                  allowClear
                  placeholder="Select all"
                  filterOption={(input: any, option: any) => {
                    return (
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    );
                  }}
                >
                  {insulationDetail?.applicableServices?.map(
                    (com: any, key: any) => (
                      <Option value={com.id} key={`${key}${com.id}`}>
                        {com.label}
                      </Option>
                    ),
                  )}
                </Select>
              </Form.Item>
            </Col>

            <Col span={5}>
              <Form.Item
                name="area"
                label="Area"
                className="title-filter-request"
                getValueFromEvent={(value: any) => {
                  handleAresChange(value);
                  return value;
                }}
              >
                <Select
                  mode="multiple"
                  size="large"
                  allowClear
                  placeholder="Select all"
                  filterOption={(input: any, option: any) => {
                    return (
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    );
                  }}
                >
                  {insulationDetail?.area?.map((com: any, key: any) => (
                    <Option value={com.id} key={`${key}${com.id}`}>
                      {com.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col span={2} className="padding-btn-export">
              <Button
                type="primary"
                size="large"
                onClick={() => setShowAddPopup(true)}
              >
                Add Company
              </Button>
            </Col>
          </Row>
        </div>
      </Form>

      {showAddPopup && (
        <AddEditPopup
          title="Create Service Provider"
          isVisible={showAddPopup}
          labelConfirm="Create"
          handleCancel={() => setShowAddPopup(false)}
          typePopup="add"
          actionTable={actionTable}
        />
      )}
    </>
  );
};

export default withForm<SearchToolProps>({
  name: 'insulationDetailSearch',
  preload: [
    {
      name: 'getinsulationDetail',
      url: APIS.META_DATA_INSULATION_DETAIL,
      method: 'GET',
    },
  ],
})(SearchTool);
